export default (superClass) => {
    return class extends superClass {
        get complianceExample() {
            return this._data.compliance_example;
        }
    
        get sekkiUrl() {
            return this._data.compliance_sekki_url;
        }
    
        get isSkefMember() {
            return this._data.is_skef_member;
        }
    }
}